import { MouseEvent, useEffect, useState } from "react";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";

import {
  selectBrands,
  selectCollections,
  selectPetCollection,
} from "../../redux/shop/shop.selectors";
import {
  Collection,
  // SubPetCollection,
  Item,
} from "../../redux/shop/shop.types";

import useStyles from "./shop-by-pet-menu.styles";

const SubMenu = (props: any) => {
  const { eachPetCollection, selected } = props;

  const classes = useStyles({ selected });

  return (
    <div className={classes.subMenuContainer}>
      {eachPetCollection.collections?.map(
        (eachSubPetCollection: Collection) => (
          <div
            key={eachSubPetCollection.id}
            className={classes.subLinkContainer}
          >
            <Link
              to={`/shop?collectionId=${eachSubPetCollection.id}`}
              className={classes.subLink}
            >
              {eachSubPetCollection.title}
            </Link>
            <div className={classes.subSubLinkContainer}>
              {eachSubPetCollection.collections?.map(
                (eachSubSubPetcollection: Collection) => (
                  <Link
                    key={eachSubSubPetcollection.id}
                    to={`/shop?collectionId=${eachSubSubPetcollection.id}`}
                    className={classes.subSubLink}
                  >
                    {eachSubSubPetcollection.title}
                  </Link>
                ),
              )}
            </div>
          </div>
        ),
      )}
    </div>
  );
};

const MainLink = (props: any) => {
  const { eachPetCollection, selectedCollection, handleEnter } = props;
  const [selected, setSelected] = useState(
    selectedCollection === eachPetCollection?.id,
  );

  const classes = useStyles({ selected });

  useEffect(() => {
    setSelected(selectedCollection === eachPetCollection?.id);
  }, [selectedCollection]);

  return (
    <div key={eachPetCollection.id} className={classes.mainLinkContainer}>
      <Link
        id={eachPetCollection.id}
        to={`/shop?collectionId=${eachPetCollection.id}`}
        className={classes.mainLink}
        onMouseEnter={handleEnter}
      >
        {eachPetCollection.title}
      </Link>
      <SubMenu eachPetCollection={eachPetCollection} selected={selected} />
    </div>
  );
};

const ShopByPetMenu = ({ open, setOpen }: { open: boolean; setOpen: any }) => {
  const location = useLocation();

  const petCollection = useSelector(selectPetCollection);
  const brands = useSelector(selectBrands);

  const [selectedCollection, setSelectedCollection] = useState(
    petCollection.collections[0]?.id,
  );

  const classes = useStyles({ open });

  const handleEnter = (e: MouseEvent) => {
    setSelectedCollection(e.currentTarget.id);
  };

  const handleClose = () => {
    setSelectedCollection(petCollection.collections[0].id);
    setOpen(false);
  };

  useEffect(() => {
    setSelectedCollection(petCollection.collections[0]?.id);
    setOpen(false);
  }, [location, petCollection]);

  return (
    <div className={classes.container}>
      <div className={classes.closeBtn} onClick={handleClose}>
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          viewBox="0 0 30 30"
        >
          <path d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z" />
        </svg>
      </div>
      {petCollection.collections.map((eachPetCollection: Collection) => (
        <MainLink
          key={eachPetCollection.id}
          eachPetCollection={eachPetCollection}
          selectedCollection={selectedCollection}
          handleEnter={handleEnter}
        />
      ))}
      <div className={classes.featuredBrandContainer}>
        <div className={classes.featuredBrandTitle}>Featured Brand</div>
        <div className={classes.brandContainer}>
          {brands
            .filter((brand: any, index: number) => index < 6)
            .map((brand: any) => (
              <Link
                key={brand.dashboardCollection}
                to={`/shop?brandId=${brand.dashboardCollection}`}
                className={classes.brand}
              >
                {brand.brandName}
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ShopByPetMenu;
